import MultipleRadios from "@/pages/components/form/input-only/multiple-radios.vue";
import Input from "@/pages/components/form/input-only/input.vue";

export default {
	components: { MultipleRadios, Input },
	props: {
		modelValue: {
			required: true,
		},
		name: {
			required: true,
			type: String,
		},
		label: {
			required: true,
			type: String,
		},
		extra: {
			required: false,
			type: String,
		},
		callback: {
			required: true,
		},
		groupClasses: {
			type: String,
			required: false,
		},
		required: {
			type: Boolean,
			default: true,
		},
		cylinders: {
			type: Array,
			required: false,
		},
	},
	data() {
		return {
			inputValue: this.modelValue,
		};
	},
	computed: {
		currentCylinder() {
			return this.cylinders.find(cylinder => cylinder.type === this.name);
		},
		isWithinMargin() {
			if(this.currentCylinder !== undefined) {
				return this.callback(this.currentCylinder.custom_value, this.inputValue);
			}
			return false;
		},
		computedValue() {
			return this.isWithinMargin ? 'OK' : 'Fout';
		}
	},
	methods: {
		handleInput(value) {
			this.inputValue = value;
			this.$emit('update:option', this.currentCylinder.custom_value + '|' + this.computedValue);
			this.$emit('update:modelValue', value);
		},
	},
}